
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emporium/apostle/bounties",
      function () {
        return require("private-next-pages/emporium/apostle/bounties.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emporium/apostle/bounties"])
      });
    }
  